import { useCallback } from 'react';

import URLSearchParamsUtils, { getURLParamValue } from 'utility/Provide/Url';
import { callApi } from 'utility/Request/callApi';

import { ApiEndpoint } from 'types/Request/endpoint';

export const useAirportApi = () => {
    const fetchAirportList = useCallback(async (searchTerm: string) => {
        try {
            const queryParams = URLSearchParamsUtils.fromObject({
                term: searchTerm,
                v: '2_0_0',
                acAirportVersion: '2',
            });

            const regionId = getURLParamValue('areaId');
            regionId && queryParams.append('regionId', regionId);

            const response = await callApi(ApiEndpoint.AirportAutocompleter, {
                //url: 'https://urlaub.check24.de/autocompleter-airports', // helpful for testing local
                queryParams,
            });

            return response.parsedBody ?? [];
        } catch (error) {
            throw new Error(
                (error as Record<string, unknown>).message as string
            );
        }
    }, []);

    return {
        searchResultProvider: fetchAirportList,
    };
};
